var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',{staticClass:"navbar navbar-light bg-white hide-empty px-5 py-3"},[_vm._t("context-actions")],2),_c('div',{staticClass:"px-5 py-5"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }